import { render, staticRenderFns } from "./animatedSection.vue?vue&type=template&id=37756c3f&scoped=true"
import script from "./animatedSection.vue?vue&type=script&lang=js"
export * from "./animatedSection.vue?vue&type=script&lang=js"
import style0 from "./animatedSection.vue?vue&type=style&index=0&id=37756c3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37756c3f",
  null
  
)

export default component.exports